
import AccountSidebar from '@marketplace/components/account/AccountSidebar.vue'

import DefaultLayout from './default.vue'

export default {
    name: 'AccountPagesLayout',

    components: {
        DefaultLayout,
        AccountSidebar,
    },
    data() {
        return {
            inboxUrl: false,
        }
    },

    computed: {
        mobilePaddingClass() {
            return this.inboxUrl ? 'mobile:p-6' : ''
        },
        mobilePaddingContainerClass() {
            return this.inboxUrl ? 'mobile:py-4' : ''
        },
    },

    watch: {
        $route(to, from) {
            this.checkUrl()
        },
    },

    mounted() {
        this.checkUrl()
    },

    methods: {
        checkUrl() {
            const currentPath = this.$route.path
            const matchingPaths = '/account/inbox'
            this.inboxUrl = currentPath.includes(matchingPaths)
        },
    },
}
